// Use const object for connect shallow equal matches
const EMPTY_OBJECT = {};
export function selectBusyState(state, id) {
    return state.ui.busy[id];
}
export function selectSelectionDisabledState(state, id) {
    return state.ui.selectionDisabled[id];
}
export function selectLayoutState(state, id) {
    return state.ui.birdLayout.byId[id] || EMPTY_OBJECT;
}
export function selectChildKeys(state, id) {
    var _a;
    return (_a = state.ui.birdLayout.byId[id]) === null || _a === void 0 ? void 0 : _a.childKeys;
}
export function selectStyleState(state, id) {
    return state.styles[id];
}
export function selectMessageState(state, id) {
    return state.ui.message[id];
}
export function selectAboutInfoState(state, id) {
    return state.aboutInfo[id];
}
export function selectAutoInteractionState(state, id) {
    return state.autoInteractions[id];
}
export function selectTitleState(state, id) {
    return state.titles[id];
}
export function selectBirdElementsState(state) {
    return state.birdElements || EMPTY_OBJECT;
}
export function selectBirdBreadcrumbState(state, id) {
    return state.breadcrumbs[id] || [];
}
export function selectBirdRichTextState(state, id) {
    return state.birdElements.Text[id] || EMPTY_OBJECT;
}
export function selectBirdSliderState(state, id) {
    return state.birdElements.Slider[id] || EMPTY_OBJECT;
}
export function selectBirdButtonBarState(state, id) {
    return state.birdElements.ButtonBar[id] || EMPTY_OBJECT;
}
export function selectBirdImageState(state, id) {
    return state.birdElements.Image[id] || EMPTY_OBJECT;
}
export function selectBirdTextFieldState(state, id) {
    return state.birdElements.TextField[id] || EMPTY_OBJECT;
}
export function selectBirdWebContentState(state, id) {
    return state.birdElements.WebContent[id] || EMPTY_OBJECT;
}
export function selectBirdJobContentState(state, id) {
    return state.birdElements.JobContent[id] || EMPTY_OBJECT;
}
export function selectBirdStackContainerState(state, id) {
    return state.birdElements.StackContainer[id] || EMPTY_OBJECT;
}
export function selectBirdPromptContainerState(state, id) {
    return state.birdElements.PromptContainer[id] || EMPTY_OBJECT;
}
export function selectBirdComboBoxState(state, id) {
    return state.birdElements.ComboBox[id] || EMPTY_OBJECT;
}
export function selectWarningState(state, id) {
    return state.ui.warning[id] || EMPTY_OBJECT;
}
export function selectBirdRadioListState(state, id) {
    return state.birdElements.RadioList[id] || EMPTY_OBJECT;
}
export function selectStatusState(state, id) {
    return state.ui.status[id];
}
export function selectBirdCheckboxListState(state, id) {
    return state.birdElements.CheckboxList[id] || EMPTY_OBJECT;
}
export function selectVisualizationState(state, id) {
    return state.birdElements.DataVisualizations[id] || EMPTY_OBJECT;
}
export function selectInfoBarState(state, id) {
    return state.birdElements.InfoBar[id] || EMPTY_OBJECT;
}
export function selectDragModeState(state, id) {
    return state.ui.dragMode[id];
}
export function selectZoomState(state, id) {
    return state.ui.zoom[id];
}
export function selectAccessibilityLabelState(state, id) {
    return state.accessibilityLabel[id];
}
export function selectOverviewState(state, id) {
    return state.ui.overview[id];
}
export function selectLayerVisibilityState(state, id) {
    return state.ui.layerVisibility[id];
}
export function selectMaximizeState(state, id) {
    return state.ui.maximize[id];
}
export function selectPromptHeaderState(state, id) {
    return state.ui.promptHeader[id];
}
export function selectElementDecoratorState(state, id) {
    return state.ui.elementDecorator[id];
}
export function selectObjectSearchState(state, id) {
    return state.ui.objectSearch[id];
}
export function selectPromptHeaderFlexDirection(state, id) {
    var _a;
    switch ((_a = state.ui.promptHeader[id]) === null || _a === void 0 ? void 0 : _a.location) {
        case 'bottom':
            return 'column-reverse';
        case 'left':
            return 'row';
        case 'right':
            return 'row-reverse';
    }
    return 'column';
}
